<template>
  <div class="userInfo">
    <div class="content" v-loading="loading">
      <div class="userContent">
        <div class="avatar" @click="showModal = true">
          <img :src="!userInfo.headPortrait ? '/images/default_avatar.png' : userInfo.headPortrait" alt="">
        </div>
        <div class="userInfoCenter" @click="showModal = true">
          <div class="name">{{ userInfo.nickName }}</div>
          <div class="phone">
            {{ userInfo.phone }} <span>单位：{{ userInfo.companyName }}</span>
          </div>
        </div>
        <div class="userRight">
          <div class="top">
            <div class="topItem" @click.stop="jumpCenterPage">福利卡余额<span>{{ !userInfo.welfarePoint ? 0.00 :
              userInfo.welfarePoint }}</span></div>
            <div class="topItem" @click.stop="jumpSpecialZone">专区余额<span>{{ specialZoneList && specialZoneList.length >
              0 ?
              specialZoneList[0].integral :
              '0.00' }}</span></div>
          </div>
          <div class="myCard">
            <div class="myCard_left">
              <img src="/images/personal/card.png" alt="">
            </div>
            <div class="myCard_c" @click="jumpCard">
              <div class="word1">我的卡包</div>
              <div class="word2">查看详情</div>
            </div>
            <div class="myCard_right" @click="jumpRecord">兑换记录</div>
          </div>
        </div>
      </div>
      <div class="order-box">
        <div class="title" @click="jumpOrder(1)">我的订单 <i class="el-icon-arrow-right" color="#4C4C4C"></i></div>
        <div class="order-list">
          <div class="item" @click="jumpOrder(2)">
            <img src="/images/order_icon2.png" alt="">
            <span>待付款</span>
          </div>
          <div class="item" @click="jumpOrder(3)">
            <img src="/images/order_icon3.png" alt="">
            <span>待发货</span>
          </div>
          <div class="item" @click="jumpOrder(4)">
            <img src="/images/order_icon4.png" alt="">
            <span>待收货</span>
          </div>
          <div class="item" @click="jumpOrder(5)">
            <img src="/images/order_icon5.png" alt="">
            <span>已完成</span>
          </div>
          <div class="item" @click="jumpRefund">
            <img src="/images/order_icon6.png" alt="">
            <span>退款/售后</span>
          </div>
        </div>
        <div class="allOrder" @click="jumpOrder(1)">查看全部订单 <i class="el-icon-arrow-right" color="#7F7B7D"></i></div>
      </div>
      <div class="contentList" v-if="collectList.length > 0 || carlist.length > 0 || browseRecord.length > 0" @click="jumpCollect">
        <div class="listItem" v-if="collectList.length > 0">
          <div class="title">我的收藏 <i class="el-icon-arrow-right" color="#4C4C4C"></i></div>
          <div class="itemCon">
            <div class="item" v-for="(item, index) in collectList" :key="index">
              <img :src="item.spuPicUrl" alt="" />
              <span>{{ item.spuName }}</span>
            </div>
          </div>
        </div>
        <div class="listItem" v-if="browseRecord.length > 0" @click="jumpBrowseRecord">
          <div class="title">我的足迹 <i class="el-icon-arrow-right" color="#4C4C4C"></i></div>
          <div class="itemCon">
            <template v-for="(item) in browseRecord">
              <div class="item" v-for="(item1, index1) in item.list" :key="index1">
                <img :src="item1.spuPicUrl" alt="" />
                <span>{{ item1.spuName }}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="listItem" v-if="carlist.length > 0" @click="jumpCart">
          <div class="title">我的购物车 <i class="el-icon-arrow-right" color="#4C4C4C"></i></div>
          <div class="itemCon">
            <div class="item" v-for="(item, index) in carlist" :key="index">
              <img :src="item.spu.picUrl" alt="" />
              <span>{{ !item.spuName ? item.spu.name : item.spuName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="goods-box" v-if="false">
        <div class="like-box">
          <div class="line"></div>
          <span class="title">猜你喜欢</span>
          <div class="line"></div>
        </div>
        <div class="goods-list">
          <ul class="list1">
            <li class="goods_box" v-for="(item, index) in goodsList" :key="index" @click="jumpDetail(item)">
              <div class="item">
                <img :src="item.picUrl" alt="">
                <div class="info">
                  <div class="name">{{ item.name }}</div>
                  <div class="num">已售{{ item.salesCount }}</div>
                  <div class="price"><span>￥</span>{{ (Number(item.price) / 100).toFixed(2) }}</div>
                </div>
              </div>
            </li>
          </ul>
          <div
            style="width: 100%;height: 300px;display: flex;justify-content: center;align-items: center;margin-top: 20px;"
            v-if="goodsList.length == 0">
            <el-empty description=" "></el-empty>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 40px;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
              :current-page="pageNum" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改信息 -->
    <modal title="修改个人信息" btnType="1" :showModal="showModal" @cancel="closeModal" @submit="saveUserInfo">
      <template #body>
        <div class="edit-wrap" v-loading="modalLoading">
          <div class="mode-item">
            <span>头像：</span>
            <el-upload class="avatar-uploader" action="https://shop.crcchc.com/api/api/file/upload" :headers="headers"
              :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :limit="1">
              <div class="add">
                <img v-if="avatarUrl" :src="avatarUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
          </div>
          <div class="mode-item">
            <span>昵称：</span>
            <input type="text" class="input" maxlength="8" placeholder="昵称" v-model="nickName" />
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/Modal';
import { mapState } from 'vuex';
export default {
  name: 'userInfo',
  components: {
    Modal
  },
  data() {
    return {
      showModal: false,
      loading: false,
      modalLoading: false,
      nickName: '',
      avatarUrl: '',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('wckj-Token')
      },
      userInfo: {},
      goodsList: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      specialZoneList: [],
      collectList: [],
      browseRecord: [],
      carlist: [],
    };
  },
  mounted() {
    this.$store.dispatch('savePersonType', 5)
    this.loading = true
    this.getUserInfo()
    this.getGoodsList()
    this.getSpecialZoneList()
    this.getCollectList()
    this.getBrowseRecord()
    this.getCartList()
  },
  computed: {
    ...mapState(['themeColor'])
  },
  methods: {
    // 跳转卡包
    jumpCard() {
      // this.$store.dispatch('savePersonType', 12)
      this.$router.push('/cardBag');
    },
    // 跳转兑换记录
    jumpRecord() {
      this.$router.push('/exchangeRecord');
    },
    // 福利卡
    jumpCenterPage() {
      this.$store.dispatch('savePersonType', 3)
      this.$store.dispatch('saveMessageType', '')
      this.$router.push('/benefitCard');
    },

    // 跳转专区
    async jumpSpecialZone() {
      // 
      this.$store.dispatch('savePersonType', 22)
      this.$store.dispatch('saveMessageType', '')
      this.$router.push('/specialZone')
    },
    // 跳转商品详情
    jumpDetail(item, type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (item.productType == 1) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "jdDetail",
        });
      } else if (item.productType == 2) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', 1)
        this.$router.push({
          name: "cakeDetail",
        });
      } else {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', type)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "detail",
        });
      }
    },
    // 跳转订单
    jumpOrder(type) {
      this.$store.dispatch('savePersonType', 1)
      this.$store.dispatch('saveOrderType', type)
      this.$router.push('/orderList');
    },
    // 跳转售后订单
    jumpRefund() {
      this.$store.dispatch('savePersonType', 1)
      this.$store.dispatch('saveOrderType', 16)
      this.$router.push('/refundOrderList');
    },
    // 关闭弹框
    closeModal() {
      this.showModal = false
      this.avatarUrl = ''
      this.nickName = ''
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.avatarUrl = file.response.data.url;
        this.modalLoading = false
      } else if (res.code == 500) {
        this.$message.warning(res.msg)
        this.modalLoading = false
      } else if (res.code == 401) {
        this.modalLoading = false
        this.$router.push('/login')
      }

    },
    beforeAvatarUpload(file) {
      this.modalLoading = true
    },
    // 保存个人信息
    saveUserInfo() {
      this.showModal = false
      this.loading = true
      this.$api.mall.changeInfo({
        nickName: this.nickName,
        wxHead: this.avatarUrl
      }).then((res) => {
        console.log(res, '保存个人信息');
        if (res.code == 200) {
          this.$message.success('保存成功');
          this.getUserInfo()
        }
        this.loading = false
      });
    },
    // 获取个人信息
    getUserInfo() {
      this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
          this.avatarUrl = res.data.userInfo.headPortrait
          this.nickName = res.data.userInfo.nickName
        }
      });
    },
    // 获取猜你喜欢
    getGoodsList() {
      this.$api.mall.getIndexGroupProduct({
        id: 1,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        console.log(res, '商品列表');
        if (res.code == 200) {
          this.goodsList = !res.data.rows ? [] : res.data.rows
          this.total = !res.data.total ? 0 : res.data.total
        }
        this.loading = false
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.loading = true
      this.getGoodsList(1)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.goodsList = []
      this.loading = true
      this.getGoodsList(1)
    },

    // 获取专区数据
    getSpecialZoneList() {
      this.$api.mall.userActivityIntegralList({
        pageNum: 1,
        pageSize: 1,
        cardType: 0
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.specialZoneList = res.rows
        }
      })
    },

    // 获取商品列表
    getCollectList() {
      this.$api.mall.getCollectList({
        pageNum: 1,
        pageSize: 2
      }).then((res) => {
        console.log(res, '猜你喜欢');
        if (res.code == 200) {
          let data = !res.rows ? [] : res.rows
          this.collectList = data
        }
        this.$forceUpdate()
      });
    },

    // 获取商品列表
    getBrowseRecord() {
      this.$api.mall.getBrowseRecord({
        pageNum: 1,
        pageSize: 2
      }).then((res) => {
        console.log(res, '浏览记录');
        if (res.code == 200) {
          this.browseRecord = !res.data || JSON.stringify(res.data) == '{}' ? [] : res.data
        }
        this.$forceUpdate()
      });
    },

    // 获取购物车
    getCartList() {
      this.$api.mall.getCarList().then(res => {
        if (res.code == 200) {
          let dataList = []
          dataList = res.data.validList.length == 0 ? [] : res.data.validList
          this.carlist = dataList.length >= 2 ? dataList.slice(0, 2) : dataList
        }
        this.$forceUpdate()
      })
    },
    jumpCollect() {
      this.$router.push('/collectRecord');
    },
    jumpCart() {
      this.$router.push('/cart');
    },
    jumpBrowseRecord() {
      this.$router.push('/browseRecord');
    },
  }
};
</script>
<style lang="scss" scoped>
.userInfo {
  width: 100%;
  min-height: 820px;

  .content {
    width: 100%;

    .userContent {
      width: 100%;
      height: 155px;
      background: linear-gradient(270deg, #FFF5EC 0%, #FFF6EE 100%);
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 16px 20px;
      box-sizing: border-box;

      .avatar {
        width: 123px;
        height: 123px;

        img {
          width: 123px;
          height: 123px;
        }
      }

      .userInfoCenter {
        flex: 1;
        margin-left: 16px;

        .name {
          font-weight: 700;
          font-size: 25px;
          color: #111111;
          line-height: 34px;
        }

        .phone {
          font-size: 14px;
          color: #111111;
          line-height: 20px;
          margin-top: 8px;

          span {
            font-size: 14px;
            color: #777777;
            margin-left: 30px;
          }
        }
      }

      .userRight {
        width: 382px;
        height: 122px;
        background: #FFFFFF;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 14px 0;

        .top {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          &::after {
            content: '';
            width: 1px;
            height: 14px;
            background: #EBEBEB;
            position: absolute;
            left: 181px;
            top: 3px;
          }

          .topItem {
            width: 50%;
            font-size: 14px;
            color: #10192D;
            line-height: 20px;
            text-align: center;
            span {
              font-weight: 600;
              font-family: PingFangSC, PingFang SC;
              margin-left: 6px;
            }
          }
        }

        .myCard {
          width: 345px;
          height: 57px;
          background: #FFF2EB;
          border-radius: 8px;
          margin: 15px auto 0;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 14px;
          box-sizing: border-box;

          .myCard_left {
            width: 22px;
            height: 25px;

            img {
              width: 22px;
              height: 25px;
            }
          }

          .myCard_c {
            flex: 1;
            margin-left: 12px;

            .word1 {
              font-weight: 600;
              font-size: 16px;
              color: #10192D;
            }

            .word2 {
              font-size: 14px;
              color: #FF1D18;
              font-family: PingFangSC, PingFang SC;
            }
          }

          .myCard_right {
            width: 78px;
            height: 29px;
            line-height: 29px;
            text-align: center;
            background: #FF1D18;
            border-radius: 4px;
            font-size: 14px;
            color: #FFFFFF;
            font-family: PingFangSC, PingFang SC;
          }
        }
      }
    }

    .order-box {
      width: 100%;
      background-color: #fff;
      margin-top: 15px;
      padding: 12px 0 40px 0;
      line-height: 22px;
      box-sizing: border-box;

      .title {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 700;
        font-family: PingFangSC, PingFang SC;
      }

      .order-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;

        .item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          img {
            width: 29px;
            height: 25px;
            display: block;
          }

          span {
            font-size: 14px;
            color: #1E1E1F;
            margin-top: 11px;
          }

          .title {
            font-size: 14px;
            color: #4c4948;
          }
        }
      }

      .allOrder {
        font-size: 16px;
        color: #787878;
        line-height: 22px;
        text-align: center;
        line-height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
      }
    }

    .contentList {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 0 12px;
      margin-top: 33px;

      .listItem {
        width: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 12px 20px 16px 20px;
        box-sizing: border-box;

        .title {
          font-size: 16px;
          color: #111111;
          line-height: 22px;
        }

        .itemCon {
          display: flex;
          margin-top: 12px;

          .item {
            width: calc(50% - 8px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &:first-child {
              margin-right: 16px;
            }

            img {
              width: 131px;
              height: 131px;
              border-radius: 5px;
            }

            span {
              font-size: 14px;
              color: #333333;
              line-height: 20px;
              margin-top: 4px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }
          }
        }

      }
    }

    .goods-box {
      width: 100%;
      background-color: #fff;
      margin-top: 15px;

      .like-box {
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;

        .line {
          width: 80px;
          height: 1px;
          background-color: #f5f5f5;
        }

        span {
          font-size: 18px;
          font-weight: bold;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }

      .goods-list {
        width: 100%;
        padding: 0 25px 30px;
        box-sizing: border-box;

        .list1 {
          width: 100%;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          grid-gap: 15px;
          padding-left: 0;

          .goods_box {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 0 15px 20px 0;

            .item {
              width: 100%;
              border-radius: 4px;
              background-color: #f5f5f5;
              box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.05);

              img {
                width: 100%;
                height: 177px;
                border-radius: 8px 8px 0 0;
              }

              .info {
                width: 100%;
                height: 88px;
                background-color: #f5f5f5;
                padding: 10px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                border-radius: 0 0 8px 8px;

                .name {
                  width: 100%;
                  font-size: 14px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  word-break: break-all;
                }

                .num {
                  width: 100%;
                  text-align: center;
                  font-size: 12px;
                  color: #999999;
                }

                .price {
                  width: 100%;
                  font-size: 16px;
                  color: #e60012;
                  text-align: center;

                  span {
                    font-size: 10px;
                  }
                }
              }
            }
          }

          .goods_box:nth-child(6n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .edit-wrap {
    font-size: 14px;

    .mode-item {
      margin-bottom: 15px;
      display: flex;
      align-items: center;

      .input {
        display: inline-block;
        width: 400px;
        height: 40px;
        line-height: 40px;
        padding-left: 15px;
        border: 1px solid #e5e5e5;
        margin-right: 14px;

        &+.input {
          margin-left: 14px;
        }
      }

      .add {
        width: 100px;
        height: 100px;
        border: 1px dashed #ccc;
        box-sizing: border-box;
        border-radius: 4px;
      }

      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }

      .avatar {
        width: 100px;
        height: 100px;
        display: block;
        border-radius: 4px;
      }
    }
  }
}
</style>